import React from "react";
import { Modal } from "antd";
import LabeledInput from "../ui/LabeledInput";
import Dropdown from "../ui/Dropdown";

const AddReaderModal = ({ visible, onCancel, onSubmit, formData, setFormData, dropdownOptions }) => {
  
  const handleChange = (key, value) => {
    setFormData((prev) => ({ ...prev, [key]: value }));
  };

  return (
    <Modal
      title="Add New Reader"
      visible={visible}
      onCancel={onCancel}
      onOk={onSubmit}
      okText="Submit"
      width={700}
    >
      <div className="space-y-4">
        {/* Two per row */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <LabeledInput
            label="First Name"
            value={formData.firstname}
            onChange={(e) => handleChange("firstname", e.target.value)}
          />
          <LabeledInput
            label="Last Name"
            value={formData.lastname}
            onChange={(e) => handleChange("lastname", e.target.value)}
          />
          <LabeledInput
            label="Email"
            value={formData.email}
            onChange={(e) => handleChange("email", e.target.value)}
          />
          <LabeledInput
            label="Mobile"
            value={formData.mobile}
            onChange={(e) => handleChange("mobile", e.target.value)}
          />
          <LabeledInput
            label="Job title"
            value={formData.jobtitle}
            onChange={(e) => handleChange("jobtitle", e.target.value)}
          />
          <Dropdown
            label="State"
            options={dropdownOptions.states}
            value={formData.state_id}
            onChange={(val) => handleChange("state_id", val)}
          />
          <LabeledInput
            label="Password"
            value={formData.password}
            onChange={(e) => handleChange("password", e.target.value)}
            type="password"
          />
          <LabeledInput
            label="Confirm Password"
            value={formData.confirmpassword}
            onChange={(e) => handleChange("confirmpassword", e.target.value)}
            type="password"
          />
        </div>
      </div>
    </Modal>
  );
};

export default AddReaderModal;